import React from 'react';

const Tip = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99984 1.66675C6.78317 1.66675 4.1665 4.28341 4.1665 7.50008C4.1665 9.48341 5.15817 11.2251 6.6665 12.2834V14.1667C6.6665 14.6251 7.0415 15.0001 7.49984 15.0001H12.4998C12.9582 15.0001 13.3332 14.6251 13.3332 14.1667V12.2834C14.8415 11.2251 15.8332 9.48341 15.8332 7.50008C15.8332 4.28341 13.2165 1.66675 9.99984 1.66675ZM7.49984 17.5001C7.49984 17.9584 7.87484 18.3334 8.33317 18.3334H11.6665C12.1248 18.3334 12.4998 17.9584 12.4998 17.5001V16.6667H7.49984V17.5001ZM11.6665 11.4167L12.3748 10.9167C13.4998 10.1334 14.1665 8.85841 14.1665 7.50008C14.1665 5.20008 12.2998 3.33341 9.99984 3.33341C7.69984 3.33341 5.83317 5.20008 5.83317 7.50008C5.83317 8.85841 6.49984 10.1334 7.62484 10.9167L8.33317 11.4167V13.3334H11.6665V11.4167Z"
      fill="#12B886"
    />
  </svg>
);

export default Tip;
